export default __webpack_public_path__ + "static/media/google.7833784a.svg";